import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/locations/page";

export const Route = createFileRoute("/admin/add-client/$clientId/locations")({
  component: Page,
});
